<template>
  <div>
    <el-header>
      <h3 class="title">
        <div class="block">
          <span>微博接入</span>
        </div>
      </h3>
    </el-header>
    <el-row type="flex" justify="center">
      <el-col class="max-block" :span="14">
        <div class="sweep-code">
          <div class="info-block-bg">
            <div class="">
              <div class="logo-wrapper">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconweibo"></use>
                </svg>
              </div>
            </div>
            <div class="info-block-right">
              <h5>只需将您的微博账号绑定到客服系统就可以轻松处理来自微博账号用户的咨询。</h5>
              <el-button
                type="info"
                size="small"
                @click="bindWeibo"
              >绑定微博客服</el-button>
            </div>
          </div>
        </div>
        <el-alert
          title="微博账号必须是认证过的微博V号或服务号，否则无法正常接收消息"
          type="warning"
          :closable="false"
          show-icon>
        </el-alert>
      </el-col>
    </el-row>
    <el-table size="small" style="width: 100%">
      <el-table-column label="微博名称" align="center"></el-table-column>
      <el-table-column label="技能组" align="center"></el-table-column>
      <el-table-column label="启用客服机器人" header-align="center"></el-table-column>
      <el-table-column label="最后更新时间" header-align="center"></el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template>
          <el-tooltip class="item" effect="light" content="修改" placement="bottom">
            <el-button
              type="text"
              size="small"
            >
              <svg class="icon icon-bianji" aria-hidden="true">
                <use xlink:href="#icontable-bianji" />
              </svg>
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="light" content="删除" placement="bottom">
            <el-button
              type="text"
              @click="deleteItem()"
              size="small"
            >
              <svg class="icon icon-delete" aria-hidden="true">
                <use xlink:href="#icontable-delete" />
              </svg>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'weibo',
  data() {
    return {
      resource: '',
      modeFlag: true
    }
  },
  props: {
    weiboListFlag: Boolean
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    bindWeibo () {
      this.$emit('changeView', !this.weiboListFlag)
    },
    deleteItem() {
      this.$confirm('删除后将无法撤销，您是否要删除该内容？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-header {
    height: auto !important;
    margin-bottom: 10px;
    padding: 0;
    .title {
      margin-bottom: 20px;
    }
  }
  .sweep-code {
    .info-block-bg {
      align-items: center;
      width: 100%;
      margin-bottom: 15px;
      padding: 0;
      background-color: transparent;
      .logo-wrapper {
        background-color: #eee;
      }
      h5 {
        color: #666;
        line-height: 1.5;
        margin-bottom: 15px;
      }
    }
  }
  .el-alert {
    padding: 10px 20px;
    border: 1px solid transparent;
    border-radius: 2px;
    font-size: 12px;
    margin-bottom: 30px;
    &.el-alert--warning.is-light {
      background-color: #fcf7f1;
      border-color: #ffeedc;
      color: #f66f6a;
    }
  }
  .el-form {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-form-item {
      margin-bottom: 10px;
    }
    .el-button {
    }
  }

</style>
